(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["08l-product"] && !Shopify.designMode) return;
  try {
    
(function(){
  var DASH=' \u2014 ', CHECK=' \u2713';

  // ---- prev/next nav ------------------------------------------------------
  // Server-rendered links exist only inside a collection context. On a plain
  // /products/<handle> URL we resolve the neighbours from the category collection
  // and cache the handle list per collection for the rest of the session.
  (function(){
    var nav=document.querySelector('.olp__nav'); if(!nav) return;
    var prevEl=nav.querySelector('.olp__nav-prev'), nextEl=nav.querySelector('.olp__nav-next');
    var col=nav.getAttribute('data-col'), cur=nav.getAttribute('data-cur');

    function setName(link){
      var nameEl=link.querySelector('.olp__nav-name'); if(!nameEl) return;
      var m=(link.getAttribute('href')||'').match(/\/products\/([^/?#]+)/); if(!m) return;
      fetch('/products/'+m[1]+'.js').then(function(r){return r.json();})
        .then(function(p){ if(p&&p.title) nameEl.textContent=p.title; }).catch(function(){});
    }
    function apply(link, item){
      if(!link||!item) return;
      link.setAttribute('href','/collections/'+col+'/products/'+item.h);
      link.querySelector('.olp__nav-name').textContent=item.t||'';
      link.removeAttribute('hidden');
    }
    function loadCollection(){
      var key='olpcol:'+col;
      try{ var c=sessionStorage.getItem(key); if(c) return Promise.resolve(JSON.parse(c)); }catch(e){}
      var all=[];
      function page(n){
        return fetch('/collections/'+col+'/products.json?limit=250&page='+n)
          .then(function(r){ return r.ok?r.json():{products:[]}; })
          .then(function(d){
            var items=(d&&d.products)||[];
            all=all.concat(items.map(function(pr){ return {h:pr.handle,t:pr.title}; }));
            if(items.length===250 && n<8) return page(n+1);
            try{ sessionStorage.setItem(key, JSON.stringify(all)); }catch(e){}
            return all;
          });
      }
      return page(1);
    }

    var needResolve=false;
    [prevEl,nextEl].forEach(function(l){ if(!l) return; if(l.getAttribute('href')) setName(l); else needResolve=true; });
    if(!needResolve || !col || !cur) return;

    loadCollection().then(function(list){
      if(!list||!list.length) return;
      var i=-1;
      for(var k=0;k<list.length;k++){ if(list[k].h===cur){ i=k; break; } }
      if(i<0) return;
      if(prevEl && !prevEl.getAttribute('href') && i>0) apply(prevEl, list[i-1]);
      if(nextEl && !nextEl.getAttribute('href') && i<list.length-1) apply(nextEl, list[i+1]);
    }).catch(function(){});
  })();

  var form=document.getElementById('olpForm'); if(!form) return;
  var variants=[]; try{ variants=JSON.parse(form.dataset.variants); }catch(e){}
  function ud(s){ return decodeURIComponent((s||'').replace(/\+/g,' ')); }
  var prices={};
  (form.dataset.prices||'').split('|').forEach(function(pair){
    var i=pair.indexOf(':'); if(i>0) prices[pair.slice(0,i)]=ud(pair.slice(i+1));
  });
  var images={};
  (form.dataset.images||'').split('|').forEach(function(pair){
    var i=pair.indexOf(':'); if(i>0) images[pair.slice(0,i)]=ud(pair.slice(i+1));
  });
  var idInput=document.getElementById('olpVariantId');
  var priceEl=document.getElementById('olpPrice');
  var addBtn=document.getElementById('olpAdd');          /* null on blends */
  var addLabel=document.getElementById('olpAddLabel');   /* null on blends */
  var blendBtn=document.querySelector('.ol-blend-btn');  /* null everywhere else */
  var msg=document.getElementById('olpMsg');

  function selectedOptions(){
    var opts=[];
    form.querySelectorAll('.olp__opt').forEach(function(fs){
      var r=fs.querySelector('input:checked'); opts.push(r?r.value:null);
    });
    return opts;
  }
  function findVariant(opts){
    /* Single-variant products render NO option fieldsets, because the synthetic
       "Default Title" option is suppressed in the markup above. So
       selectedOptions() comes back empty, while the variant still reports
       options:["Default Title"] (length 1) - the length check below could never
       match and every heavy showed "Unavailable". There is exactly one variant
       in that case, so use it. */
    if(!opts.length) return variants[0];
    return variants.filter(function(v){
      return v.options.length===opts.length && v.options.every(function(o,i){ return o===opts[i]; });
    })[0];
  }
  function money(v){ return prices[v.id] || ('$'+(v.price/100).toFixed(2)); }
  function base(u){ return (u||'').split('?')[0]; }

  /* INCOMPATIBLE COMBINATIONS. "Fine Art Poster Print" is never offered in
     "4 x 6" (Ryan: never show Fine Art 4x6). The product DATA may still carry
     sold-out Fine-Art/4x6 variants; this HIDES the 4x6 size pill whenever Fine
     Art is selected, so the bad combo can never be seen or chosen on this PDP.
     The old fix lived in theme.liquid but only targeted the STOCK picker
     (input names "Material-..."); it never fired on this custom picker, which
     is why 4x6 Fine Art reappeared once products moved to the 08l template.
     Exact-string match, so blends (Product="Fine Art", sizes 30x20/60x40) are
     unaffected. Add more {when,hide} rules here if other combos need it. */
  var INCOMPAT = [{ when: 'Fine Art Poster Print', hide: '4 x 6' }];
  function applyIncompat(){
    var sel = selectedOptions();
    var active = INCOMPAT.filter(function(r){ return sel.indexOf(r.when) !== -1; });
    form.querySelectorAll('.olp__opt').forEach(function(fs){
      fs.querySelectorAll('.olp__pill').forEach(function(pill){
        var input = pill.querySelector('input'); if(!input) return;
        var hideThis = active.some(function(r){ return r.hide === input.value; });
        pill.style.display = hideThis ? 'none' : '';
        if(hideThis && input.checked){
          input.checked = false;
          var sibs = fs.querySelectorAll('.olp__pill');
          for(var k=0;k<sibs.length;k++){
            var si = sibs[k].querySelector('input');
            if(si && sibs[k].style.display !== 'none'){ si.checked = true; break; }
          }
        }
      });
    });
  }

  // grey out option values that have no AVAILABLE variant given the other picks
  function updateOptionAvailability(){
    var sel=selectedOptions();
    form.querySelectorAll('.olp__opt').forEach(function(fs, gi){
      fs.querySelectorAll('.olp__pill').forEach(function(pill){
        var input=pill.querySelector('input'); if(!input) return;
        var val=input.value;
        var ok=variants.some(function(v){
          if(!v.available || v.options[gi]!==val) return false;
          for(var j=0;j<sel.length;j++){ if(j!==gi && sel[j]!=null && v.options[j]!==sel[j]) return false; }
          return true;
        });
        pill.classList.toggle('is-soldout', !ok);
      });
    });
  }

  function update(){
    applyIncompat();   /* hide impossible combos (Fine Art 4x6) + fix selection BEFORE resolving */
    form.querySelectorAll('.olp__opt').forEach(function(fs){
      fs.querySelectorAll('.olp__pill').forEach(function(l){ l.classList.toggle('is-sel', !!l.querySelector('input:checked')); });
    });
    updateOptionAvailability();
    var v=findVariant(selectedOptions());
    /* On a BLEND there is no #olpAdd at all - the button is "Build your blend".
       Every addBtn/addLabel touch below must be null-guarded or the whole
       variant picker throws on the first click and stops working. */
    if(!v){ if(addBtn){ addBtn.disabled=true; addLabel.textContent='Unavailable'; } msg.textContent=''; return; }
    idInput.value=v.id;
    priceEl.textContent=money(v);
    /* keep the blend popup pointed at the variant the customer actually picked */
    if(blendBtn) blendBtn.setAttribute('data-variant', v.id);
    if(addBtn){
      if(v.available){ addBtn.disabled=false; addLabel.textContent='Add to cart'+DASH+money(v); }
      else{ addBtn.disabled=true; addLabel.textContent='Unavailable'; }
    }
    // swap main image to this variant's image (if it has one)
    var mi=document.querySelector('.olp__frame img');
    var url=images[v.id];
    if(mi && url){
      var b=base(url);
      mi.removeAttribute('srcset'); mi.src=url;
      document.querySelectorAll('.olp__thumb').forEach(function(x){ x.classList.toggle('is-sel', base(x.dataset.full)===b); });
    }
    try{ var u=new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); }catch(e){}
  }

  form.addEventListener('change', function(e){ if(e.target.matches('input[type="radio"]')) update(); });

  var mainImg=document.querySelector('.olp__frame img');
  document.querySelectorAll('.olp__thumb').forEach(function(t){
    t.addEventListener('click', function(){
      if(mainImg){ mainImg.removeAttribute('srcset'); mainImg.src=t.dataset.full; }
      document.querySelectorAll('.olp__thumb').forEach(function(x){ x.classList.remove('is-sel'); });
      t.classList.add('is-sel');
    });
  });

  // quantity stepper
  var qtyInput=document.getElementById('olpQty');
  function getQty(){ var q=parseInt(qtyInput&&qtyInput.value,10); return (q&&q>0)?q:1; }
  document.querySelectorAll('.olp__qbtn').forEach(function(b){
    b.addEventListener('click', function(){ qtyInput.value=Math.max(1, getQty()+parseInt(b.dataset.step,10)); });
  });
  if(qtyInput) qtyInput.addEventListener('change', function(){ qtyInput.value=getQty(); });

  // related airports via Shopify product recommendations
  var relWrap=document.getElementById('olpRelated');
  if(relWrap){
    var pid=relWrap.dataset.pid;
    var esc=function(s){return String(s==null?'':s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];});};
    fetch('/recommendations/products.json?product_id='+pid+'&limit=4&intent=related')
      .then(function(r){ return r.json(); })
      .then(function(d){
        var items=(d&&d.products)||[];
        if(!items.length) return;
        document.getElementById('olpRelatedGrid').innerHTML=items.map(function(pr){
          var fi=pr.featured_image, u=(typeof fi==='string')?fi:((fi&&fi.src)||'');
          var img=u?('<img src="'+u+(u.indexOf('?')>-1?'&':'?')+'width=440" alt="" loading="lazy">'):'';
          return '<a class="olp__rcard" href="'+pr.url+'"><div class="olp__rart">'+img+'</div><div class="olp__rcap">'+esc(pr.title)+'</div></a>';
        }).join('');
        relWrap.hidden=false;
      }).catch(function(){});
  }

  function cartSectionIds(){
    var ids={};
    document.querySelectorAll('cart-items-component, cart-drawer-component, cart-icon').forEach(function(el){
      var sid=el.getAttribute('data-section-id'); if(!sid){ var h=el.closest('[data-section-id]'); sid=h&&h.getAttribute('data-section-id'); }
      if(sid) ids[sid]=1;
    });
    return Object.keys(ids);
  }
  function refreshCart(res){
    fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
      try{ document.dispatchEvent(new CustomEvent('cart:update',{bubbles:true,detail:{resource:{},sourceId:'olp',data:{itemCount:cart.item_count,source:'olp',sections:(res&&res.sections)||{}}}})); }catch(e){}
      ['cart:refresh','cart:updated','cart:change'].forEach(function(n){ try{ document.documentElement.dispatchEvent(new CustomEvent(n,{bubbles:true,detail:{cart:cart}})); }catch(e){} });
    }).catch(function(){});
  }
  form.addEventListener('submit', function(e){
    e.preventDefault();
    /* HARD STOP ON BLENDS. There is no submit button on a blend, but a stray
       form submit (Enter key, an app, a future edit) must never add a blend
       straight to the cart - it would arrive with NO PICKS attached, which is
       exactly the bug that shipped once before. The popup is the only route. */
    if(blendBtn || !addBtn) return;
    var v=findVariant(selectedOptions());
    if(!v||!v.available){ msg.className='olp__msg'; msg.textContent='Please choose an available option.'; return; }
    addBtn.disabled=true; var was=addLabel.textContent; addLabel.textContent='Adding...'; msg.className='olp__msg'; msg.textContent='';
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({items:[{id:v.id,quantity:getQty()}], sections:cartSectionIds().join(','), sections_url:location.pathname})})
      .then(function(r){ if(!r.ok) throw new Error('add'); return r.json(); })
      .then(function(res){ refreshCart(res); addBtn.disabled=false; addLabel.textContent=was;
        msg.className='olp__msg ok'; msg.textContent='Added to cart'+CHECK; })
      .catch(function(){ addBtn.disabled=false; addLabel.textContent=was; msg.className='olp__msg'; msg.textContent='Something went wrong'+DASH+'please try again.'; });
  });

  update();
})();

  } catch(e) { console.error(e); }
})();
})();
